import { render, staticRenderFns } from "./ImportPhysicianList.vue?vue&type=template&id=15b3d644&scoped=true&"
import script from "./ImportPhysicianList.vue?vue&type=script&lang=js&"
export * from "./ImportPhysicianList.vue?vue&type=script&lang=js&"
import style0 from "./ImportPhysicianList.vue?vue&type=style&index=0&id=15b3d644&lang=scss&scoped=true&"
import style1 from "./ImportPhysicianList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3d644",
  null
  
)

export default component.exports